module.exports = __webpack_public_path__ + "img/s12.d688c99.png";